<template>
  <div class="wrap" v-if="reports.detail">
    <div class="top">
      <img src="../assets/img/result.png" alt="" />
      <div class="title">
        {{ jsonData.company_name }} 与 {{ jsonData.policy_title }} 体检结果
      </div>
    </div>

    <div class="content">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 匹配报告 -->
          <el-tab-pane label="匹配报告" name="first">
            <div class="border">
              <div class="title1">
                <img src="../assets/img/title-back.png" alt="" />
                <div class="text">
                  <img src="../assets/img/fenxi.png" alt="" />
                  <span>分析报告</span>
                </div>
              </div>

              <div class="context">
                <div
                  style="
                    font-weight: bold;
                    font-size: 22px;
                    margin-bottom: 20px;
                  "
                >
                  {{ jsonData.policy_title }}
                </div>
                <div style="font-size: 20px; margin-bottom: 20px">
                  综合评分：<span style="color: #ff420f; font-weight: bold">{{
                    reports.score
                  }}</span>
                  分
                </div>

                <div
                  class="tabl"
                  v-for="detail in jsonData.reports[0].report.detail"
                  :key="detail.length"
                >
                  <div class="left">{{ detail.item }}</div>
                  <div class="right">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="符合要求"
                      placement="right"
                    >
                      <img
                        v-if="detail.flag == 'suitable'"
                        src="../assets/img/yes.png"
                        alt=""
                      />
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="不符合要求"
                      placement="right"
                    >
                      <img
                        v-if="detail.flag == 'unsuitable'"
                        src="../assets/img/no.png"
                        alt=""
                      />
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="离要求还有一定距离"
                      placement="right"
                    >
                      <img
                        v-if="detail.flag == 'unenough'"
                        src="../assets/img/wenhao.png"
                        alt=""
                      />
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="缺失必要数据"
                      placement="right"
                    >
                      <img
                        v-if="detail.flag == 'miss_data'"
                        src="../assets/img/tanhao.png"
                        alt=""
                      />
                    </el-tooltip>
                    <span v-html="detail.desc"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 申报条件 -->
            <div class="border" style="margin-top: 30px">
              <div class="coll">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">
                      <div class="title2">
                        <img src="../assets/img/title-back.png" alt="" />
                        <div class="text">
                          <img src="../assets/img/zcshenbao.png" alt="" />
                          <span>本政策申报条件</span>
                        </div>
                      </div>
                    </template>
                    <div
                      v-html="jsonData.policy.declare_condition"
                      style="
                        padding: 20px 40px 0px;
                        font-size: 16px;
                        line-height: 32px;
                      "
                    ></div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <!-- 支持领域 -->
            <div class="border" style="margin-top: 30px">
              <div class="coll">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">
                      <div class="title2">
                        <img src="../assets/img/title-back.png" alt="" />
                        <div class="text">
                          <img src="../assets/img/zczhichi.png" alt="" />
                          <span>本政策支持领域</span>
                        </div>
                      </div>
                    </template>
                    <div
                      v-html="jsonData.policy.territory"
                      style="
                        padding: 20px 40px 0px;
                        font-size: 16px;
                        line-height: 32px;
                      "
                    ></div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-tab-pane>

          <!-- 政策详情 -->
          <el-tab-pane label="政策详情" name="second">
            <!-- 支持领域 -->
            <div class="box">
              <div class="top1">
                <img src="../assets/img/title-back1.png" alt="" />
                <div>
                  <img src="../assets/img/book.png" alt="" />
                  <span>支持领域</span>
                </div>
              </div>
              <div class="under">
                <div class="text1" v-html="jsonData.policy.territory"></div>
              </div>
            </div>
            <!-- 依据文件 -->
            <div class="box">
              <div class="top1">
                <img src="../assets/img/title-back1.png" alt="" />
                <div>
                  <img src="../assets/img/wenjian.png" alt="" />
                  <span>依据文件</span>
                </div>
              </div>
              <div class="under">
                <div class="text1" v-html="jsonData.policy.according"></div>
              </div>
            </div>
            <!-- 最新动态 -->
            <div class="box">
              <div class="top1">
                <img src="../assets/img/title-back1.png" alt="" />
                <div>
                  <img src="../assets/img/dongtai.png" alt="" />
                  <span>最新动态</span>
                </div>
              </div>
              <div class="under">
                <div class="text1" v-html="jsonData.policy.content"></div>
              </div>
            </div>
            <!-- 申报条件 -->
            <div class="box">
              <div class="top1">
                <img src="../assets/img/title-back1.png" alt="" />
                <div>
                  <img src="../assets/img/tiaojian.png" alt="" />
                  <span>申报条件</span>
                </div>
              </div>
              <div class="under">
                <div
                  class="text1"
                  v-html="jsonData.policy.declare_condition"
                ></div>
              </div>
            </div>
            <!-- 支持力度 -->
            <div class="box">
              <div class="top1">
                <img src="../assets/img/title-back1.png" alt="" />
                <div>
                  <img src="../assets/img/lidu.png" alt="" />
                  <span>支持力度</span>
                </div>
              </div>
              <div class="under" style="background: #fff">
                <el-table
                  class="elTable"
                  :data="tableData"
                  style="width: 95%; margin: auto; margin-top: 25px"
                  border
                  :cell-style="{ borderColor: '#b3daee' }"
                  :header-cell-style="{ borderColor: '#b3daee' }"
                >
                  <el-table-column prop="id" label="序号" width="130">
                  </el-table-column>
                  <el-table-column
                    prop="policy_level"
                    label="支持等级"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column prop="factor" label="资助条件">
                  </el-table-column>
                  <el-table-column prop="money" label="资助金额">
                  </el-table-column>
                  <el-table-column prop="file" label="参考文件">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userid: "",
      activeName: "first",
      jsonData: [],
      reports: [],
      tableData: [],
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.userid = localStorage.getItem("RealID");
      // this.userid = "10835";
      this.policy();
    });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    policy() {
      axios({
        method: "get",
        url: "http://1.192.121.29:9000/api/policy_match/report",
        params: {
          policy_id: this.$route.query.policy_id,
          user_id: this.userid,
        },
      })
        .then((res) => {
          this.jsonData = res.data;
          console.log(this.jsonData);
          this.reports = this.jsonData.reports[0].report;
          this.tableData = this.jsonData.policy.supports;
          this.reports.score = this.reports.score.toFixed(2);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  text-align: left;
  .top {
    width: 76%;
    padding: 30px;
    margin-left: 200px;
    box-shadow: 0px 0px 10px 0px rgba(150, 152, 157, 0.2);
    position: relative;
    margin-bottom: 30px;
    img {
      width: 100%;
    }
    .title {
      font-size: 25px;
      letter-spacing: 1px;
      font-weight: 600;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      text-align: center;
    }
  }

  .content {
    width: 76%;
    padding: 30px;
    box-shadow: 0px 0px 10px 0px rgba(150, 152, 157, 0.2);
    margin-left: 200px;
    .tabs {
      .border {
        width: 99%;
        margin-top: 10px;
        border: 2px solid #95e0ff;
        .title1 {
          img {
            width: 100%;
            position: relative;
          }
          .text {
            position: absolute;
            top: 32px;
            left: 40px;
            display: flex;
            img {
              width: 22px;
            }
            span {
              font-weight: bold;
              display: inline-block;
              padding-top: 1px;
              margin-left: 10px;
              font-size: 20px;
            }
          }
        }
        .title2 {
          position: relative;
          height: 70px;
          img {
            width: 101.5%;
            height: 100%;
          }
          .text {
            position: absolute;
            top: 21px;
            left: 40px;
            display: flex;
            img {
              max-width: 22px;
              max-height: 22px;
            }
            span {
              width: 300px;
              transform: translateY(-14px);
              font-weight: bold;
              display: inline-block;
              padding-top: 1px;
              margin-left: 10px;
              font-size: 20px;
            }
          }
        }

        .context {
          padding: 36px;
          padding-top: 25px;
          .tabl {
            display: flex;
            border: 1px solid #b3daee;
            .left {
              background-color: #e0f2fd;
              height: 70px;
              line-height: 70px;
              padding: 0 0 0 30px;
              font-size: 17px;
              font-weight: 600;
              min-width: 235px;
            }
            .right {
              background-color: #f7fcff;
              font-size: 16px;
              max-height: 70px;
              display: flex;
              img {
                margin: 0 45px;
                width: 24px;
                height: 24px;
                transform: translateY(20px);
              }
              span {
                display: inline-block;
                max-width: 1000px;
                padding-top: 18px;
                overflow: auto;
              }
            }
          }
        }
      }

      .box {
        margin-bottom: 30px;
        .top1 {
          position: relative;
          img {
            width: 100%;
          }
          div {
            display: flex;
            position: absolute;
            left: 40px;
            top: 22px;
            span {
              display: inline-block;
              padding-top: 2px;
              color: #fff;
              width: 300px;
              font-size: 18px;
              font-weight: 600;
            }
            img {
              max-width: 22px;
              max-height: 22px;
              margin-right: 10px;
            }
          }
        }

        .under {
          background-color: #f4fafe;
          .text1 {
            font-size: 16px;
            padding: 30px 40px;
            line-height: 30px;
          }
          ::v-deep .el-table th {
            background-color: #e0f2fd;
            height: 70px;
            text-align: center;
            color: #000;
            font-size: 17px;
            font-weight: 600;
          }
          .elTable {
            border: 1px solid #b3daee !important;
          }
        }
      }
    }
  }

  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
    height: 70px !important;
    text-align: center;
    font-size: 16px;
    color: #000;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    width: 0 !important;
  }

  ::v-deep .el-tabs__item {
    font-size: 23px !important;
    font-weight: 600;
  }

  ::v-deep .el-tabs__active-bar {
    display: none;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #2967de !important;
  }

  ::v-deep .el-tabs__item:hover {
    color: #2967de !important;
    cursor: pointer;
  }

  ::v-deep #tab-first {
    width: 50%;
    text-align: right;
    padding-right: 5%;
  }

  ::v-deep #tab-second {
    width: 50%;
    padding-left: 5%;
  }

  ::v-deep .el-tabs__nav {
    display: flex;
    width: 100%;
  }

  ::v-deep .el-collapse-item__header {
    height: auto;
  }

  ::v-deep .el-icon-arrow-right:before {
    position: relative;
    z-index: 1000;
    right: 28px;
    bottom: 5px;
  }

  ::v-deep .el-icon-arrow-right.is-active:before {
    position: relative;
    z-index: 1000;
    right: 5px;
    bottom: -30px;
  }
}
</style>